import axios from "axios";

/**
 * 공용 axios 인스턴스.
 *
 * - baseURL: REACT_APP_URL (호출부는 상대 경로만 넘긴다. 예: client.get("/shareNotices"))
 * - 요청 인터셉터: admintoken이 있으면 Authorization 헤더를 자동 주입한다.
 *   토큰이 없는 시점(로그인 전)에는 헤더를 붙이지 않으므로 로그인/공개 API에 안전하다.
 *
 * 기존에 호출마다 복붙하던 `Authorization: "Bearer " + localStorage.getItem(...)` 를
 * 이 인터셉터로 일원화한다. (일부 "Bearer" 누락 호출도 여기서 표준화됨)
 */
export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("admintoken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
